"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToolboxItems = exports.default = exports.TOOLBOX_TYPE = exports.NUMBER_INPUT_REGEX = exports.MODEL_QUESTIONS = void 0;
var MODEL_QUESTIONS = {
  PAGE: 'page',
  SECTION: 'panel',
  HEADER: 'header',
  TEXT: 'text',
  DATE: 'dateCustom',
  MULTI_CHECKBOX: 'multicheckbox',
  SINGLE_SELECT: 'singleradio',
  PHONE: 'inputphone',
  EMAIL: 'inputemail',
  NUMBER: 'inputnumber',
  BOOLEAN: 'boolean',
  DROPDOWN: 'dropdownCustom',
  EXPRESSION: 'expression',
  LONG_TEXT: 'comment',
  SIGNATURE: 'signaturepad',
  MULTIPLE_TEXT: 'multipletext',
  MATRIX_SINGLE_SELECT: 'matrix',
  MATRIX_MULTI_SELECT: 'matrixdropdown',
  RATING: 'rating',
  RANKING: 'ranking'
};
exports.MODEL_QUESTIONS = MODEL_QUESTIONS;
var TOOLBOX_TYPE = {
  PAGE: 'page',
  SECTION: 'section',
  HEADER: 'header',
  TEXT: 'text',
  DATE: 'dateCustom',
  TEXT_CUSTOM: 'textcustom',
  MULTI_CHECKBOX: 'multicheckbox',
  SINGLE_RADIO: 'singleradio',
  PHONE: 'inputphone',
  EMAIL: 'inputemail',
  NUMBERS: 'numberCustom',
  BOOLEAN: 'boolean',
  DROPDOWN_CUSTOM: 'dropdownCustom',
  EXPRESSION: 'expression',
  LONG_TEXT: 'comment',
  SIGNATURE: 'signaturepad',
  MULTIPLE_TEXT: 'multipletextcustom',
  MULTIPLE_TEXT_ITEM: 'multipletextitem',
  MATRIX_SINGLE_SELECT: 'matrix',
  MATRIX_MULTI_SELECT: 'matrixdropdown',
  MATRIX_DROPDOWN_COLUMNS: 'matrixdropdowncolumn',
  MATRIX_DROPDOWN_COLUMNS_ITEMS: 'dropdown',
  RATING_SCALE: 'rating',
  RANKING: 'ranking'
};
exports.TOOLBOX_TYPE = TOOLBOX_TYPE;
var NUMBER_INPUT_REGEX = '^[+-]?\\d{0,9}(\\.\\d{1,8})?$';
exports.NUMBER_INPUT_REGEX = NUMBER_INPUT_REGEX;
var getToolboxItems = function getToolboxItems() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (x) {
    return x;
  };
  return [{
    id: 'number',
    name: MODEL_QUESTIONS.NUMBER,
    iconName: 'icon-number',
    title: t('Numbers'),
    json: {
      type: MODEL_QUESTIONS.NUMBER,
      internalType: TOOLBOX_TYPE.NUMBERS,
      inputType: 'number',
      hideNumber: true,
      inputFormat: '[-]9{+}',
      options: {
        placeholder: '0',
        definitions: {
          '-': {
            validator: '[\\-]'
          }
        }
      },
      validators: [{
        type: 'regex',
        text: t('Please enter a valid number format.'),
        regex: NUMBER_INPUT_REGEX
      }]
    }
  }, {
    id: 'phone',
    name: MODEL_QUESTIONS.PHONE,
    iconName: 'icon-phone',
    title: t('Phone'),
    json: {
      type: MODEL_QUESTIONS.PHONE,
      internalType: TOOLBOX_TYPE.PHONE,
      inputType: 'tel',
      hideNumber: true,
      inputMask: 'phone',
      inputFormat: '(999) 999-9999',
      clearIncomplete: false,
      validators: [{
        type: 'regex',
        text: t('Please enter a valid 10-digit phone number.'),
        regex: '^[\\d]{10}$'
      }]
    }
  }, {
    id: 'email',
    name: MODEL_QUESTIONS.EMAIL,
    iconName: 'icon-email',
    title: t('Email'),
    json: {
      type: MODEL_QUESTIONS.EMAIL,
      internalType: TOOLBOX_TYPE.EMAIL,
      inputType: 'email',
      hideNumber: true,
      validators: [{
        type: 'email',
        text: t('Please enter a valid e-mail address.')
      }]
    }
  }];
};
exports.getToolboxItems = getToolboxItems;
var _default = TOOLBOX_TYPE;
exports.default = _default;